import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import EsModal from './esModal.vue';
import EsModalFooter from './esModalFooter.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'esConfirmDialog',
  props: {
    isOpen: { type: Boolean },
    header: {},
    message: {},
    onConfirm: { type: Function }
  },
  emits: ["modal-close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onClose = () => emit("modal-close");
const onUpdateVisible = (value: boolean) => {
  if (!value) {
    onClose();
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EsModal, {
    title: props.header,
    "is-open": props.isOpen,
    dismissable: "",
    "onUpdate:visible": onUpdateVisible
  }, {
    footer: _withCtx(() => [
      _createVNode(EsModalFooter, {
        confirmModalMethod: props.onConfirm,
        onModalCancel: onClose
      }, null, 8, ["confirmModalMethod"])
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.message) + " ", 1)
    ]),
    _: 1
  }, 8, ["title", "is-open"]))
}
}

})